module.exports = __webpack_public_path__ + "img/ico-moderation.ffb4f4a4.svg";